import React from 'react'
import { useGlobalDispatch } from '../../core/GlobalContext'
import { TOAST_DUCK } from '../../core/actions'
import Button from '../button'
import Text from '../text'
import * as styles from './DealCode.css'

export const DealCode = ({ code }) => {
  const { toastDispatch } = useGlobalDispatch()

  const handleCodeCopy = () => {
    console.log('Copied', code, 'to clipboard')
    toastDispatch({ type: TOAST_DUCK.SEND_TOAST, payload: { message: `Copied ${code} to clipboard` } })
    navigator.clipboard.writeText(code)
  }

  const tagColor = code?.slice(0, 1) === 'D' ? styles.debt : styles.std

  return (
    // <div className={`${styles.outer} ${code?.slice(0, 1) === 'D' ? styles.debt : styles.std}`}> -- old...
    <div className={styles.outer}>
      <Button className={`${styles.button + ' ' + tagColor}`} type='text' handleClick={handleCodeCopy}>
        <Text size='0.8' color={'var(--white-color)'} value={code} number />
      </Button>
    </div>
  )
}
